import Footer from "../../components/Landing/components/Footer/Footer";
import Navbar from "../../components/Landing/components/Navbar/Navbar";
import TalentsCTA from "../../components/Landing/components/TalentsCTA/TalentsCTA";
import TalentsFeatures from "../../components/Landing/components/TalentsFeatures/TalentsFeatures";
import TalentsHero from "../../components/Landing/components/TalentsHero/TalentsHero";
import TalentsHowItWorks from "../../components/Landing/components/TalentsHowItWorks/TalentsHowItWorks";
import TalentsTestimonial from "../../components/Landing/components/TalentsTestimonial/TalentsTestimonial";
import TalentsWhy from "../../components/Landing/components/TalentsWhy/TalentsWhy";
export default function TalentLandingPage() {
  return (
    <>
      <Navbar />
      <main className="main-landing-page">
        <TalentsHero />
        <TalentsHowItWorks />
        <TalentsWhy />
        <TalentsFeatures />
        <TalentsTestimonial />
        <TalentsCTA />
      </main>
      <Footer />
    </>
  );
}
